/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { showToast } from '../../showTost';
import { useNavigate } from 'react-router-dom';
import emptyimg from "../../assets/Image/emptyOrder.png";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
export const ImgLoad = ({ url }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  return (
    <img
      src={url}
      alt="Model"
      loading="lazy"
      onLoad={() => setImgLoaded(true)}
      onError={() => setImgLoaded(true)}
      className={`transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
    />
  )
}

const BookingPackage = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [currentBooking, setCurrentBooking] = useState([]);
  const [pastBooking, setPastBooking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [isCancelBox, setIsCancelBox] = useState("");
  const [selectReason, setSelectReason] = useState();
  const [otherReason, setOtherReason] = useState();
  const [deviceCheck, setDeviceCheck] = useState(false);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);


  const selectBtnref = useRef(0);
  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);

  const Navigate = useNavigate();

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    HandlefetchPandingData(1);
    axios.get(`${ApiBaseUrl}/customer/appint_cancel_list`)
      .then((res) => {
        // console.log("appint_cancel_list", res);
        setCancelReasonList(res.data.cancel_reason);
      })
      .catch((error) => {
        console.error(error);
      });

  }, []);

  const HandlefetchPandingData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/lab_booking_pending_list`, { id: Userid, page })
        .then((res) => {
          // console.log("lab_booking_pending_list", res);
          const { ResponseCode, lab_pending_list } = res.data;
          if (ResponseCode === 200) {
            if (lab_pending_list.length === 0 || totallength > lab_pending_list.length) NoMoreDataRef.current = false;
            if (page === 1) {
              setCurrentBooking(lab_pending_list);
              setTotalLength(lab_pending_list.length);
            } else {
              setCurrentBooking(prev => [...prev, ...lab_pending_list]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandlefetchCompleteData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/lab_booking_complete_list`, { id: Userid, page })
        .then((res) => {
          // console.log("lab_booking_complete_list", res);
          const { ResponseCode, lab_complete_list } = res.data;
          if (ResponseCode === 200) {
            if (lab_complete_list.length === 0 || totallength > lab_complete_list.length) NoMoreDataRef.current = false;
            if (page === 1) {
              setPastBooking(lab_complete_list);
              setTotalLength(lab_complete_list.length);
            } else {
              setPastBooking(prev => [...prev, ...lab_complete_list]);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleCancelAppointment = () => {

    if (!selectReason) {
      showToast({ title: t("Select Cancel Reason"), id: "error" });
      return;
    }

    if (selectReason === 4 && !otherReason) {
      showToast({ title: t("Enter Other Reason"), id: "error" });
      return;
    }

    if (Userid) {
      const Data = {
        id: Userid,
        lab_book_id: isCancelBox,
        reason_id: selectReason,
        reason: otherReason ? otherReason : ""
      };

      axios.post(`${ApiBaseUrl}/customer/cancel_lab_appointment`, Data)
        .then((res) => {
          // console.log(res);
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            setIsCancelBox("");
            HandlefetchPandingData(1);
          }

        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage(prev => prev + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (page === 1 && !NoMoreDataRef.current) return;

    if (selectBtnref.current === 0) {
      HandlefetchPandingData(page);
    } else {
      HandlefetchCompleteData(page);
    }
  }, [page])

  const HandleNavigate = (id) => {
    Navigate("/dashbord/package-details", { state: { id, isShow: selectBtnref.current } });
  };

  const AudioCallHandler = async (e, code, phone) => {
    e.stopPropagation();
    window.location.href = `tel:${code + phone}`;
  };

  const HandleSelectbtn = (index) => {
    selectBtnref.current = index;
    NoMoreDataRef.current = true;
    setTotalLength(0);
    if (index === 0) {
      HandlefetchPandingData(1);
    } else {
      HandlefetchCompleteData(1);
    }
  }

  return (
    <div>
      {loading
        ? <Loading CustomeStyle="h-[100vh] -mt-[140px] w-full flex items-center justify-center bg-white" index={0} />
        : <div className="">
          <div className="flex justify-center mt-[25px]">
            <div className="bg-[#F6F7F8] Select-btn p-[5px] rounded-[50px] flex gap-[20px]">
              <button onClick={() => HandleSelectbtn(0)} className={`${selectBtnref.current === 0 && "active"}`}>{t("Pending")}</button>
              <button onClick={() => HandleSelectbtn(1)} className={`${selectBtnref.current === 1 && "active"}`}>{t("Complete")}</button>
            </div>
          </div>

          <div className="mybooking">
            {selectBtnref.current === 0
              ? (currentBooking.length >= 1
                ? currentBooking.map((item, index) => {
                  const BgColor = item.status === "1" ? "bg-yellow-100" : item.status === "2" ? "bg-orange-100" : item.status === "3" ? "bg-cyan-100" : item.status === "4" ? "bg-blue-100" : "bg-green-100";
                  const TextColor = item.status === "1" ? "text-yellow-600" : item.status === "2" ? "text-orange-500" : item.status === "3" ? "text-cyan-700" : item.status === "4" ? "text-blue-600" : "text-green-600";
                  return <div key={index} onClick={() => HandleNavigate(item.id)} className="card-box">
                    <div className="relative">
                      <ImgLoad url={ImgBaseUrl + item.lab_logo} />
                      <div className={`absolute top-[5px] right-[5px] ${BgColor} px-[10px] rounded-[50px]`}>
                        <h1 className={`text-[15px] font-[500] ${TextColor}`}>{item.status_type}</h1>
                      </div>
                    </div>
                    <div className="p-[10px]">
                      <div className="flex items-center gap-[10px] justify-between">
                        <h1 className='text-[#0d4047] text-[15px]'>{t("Appointment ID")} {item.id}</h1>
                        <h1 className='font-[500] text-[#0d4047]'>{currency}{item.tot_price}.00</h1>
                      </div>
                      <h1 className='text-[16px] font-[500]'>{item.name}</h1>
                      <div className="flex items-center gap-[5px] text-gray-500">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#808080" stroke-width="1.5" />
                          <path d="M3 9H21" stroke="#808080" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M8 2L8 5" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M16 2V5" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <circle cx="12" cy="15" r="1" fill="#808080" />
                          <circle cx="16" cy="15" r="1" fill="#808080" />
                          <circle cx="8" cy="15" r="1" fill="#808080" />
                        </svg>
                        <span className=' text-[14px] font-[500]'>{item.date}</span>
                      </div>
                      <div className="flex items-center justify-between gap-[10px] mt-[10px]">
                        {(selectBtnref.current === 0 && item.status === "1") && <button onClick={(e) => { e.stopPropagation(); setIsCancelBox(item.id) }} className='w-[100%] border-[1px] border-[red] text-[red] rounded-[50px] py-[5px] font-[500]'>{t("Cancel")}</button>}
                        <button onClick={(e) => AudioCallHandler(e, item.country_code, item.phone)} className='w-[100%] border-[1px] border-[#0d4047] text-[#0d4047] rounded-[50px] py-[5px] font-[500] flex items-center justify-center gap-[10px]'>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 19V17.3541C21 16.5363 20.5021 15.8008 19.7428 15.4971L17.7086 14.6835C16.7429 14.2971 15.6422 14.7156 15.177 15.646L15 16C15 16 12.5 15.5 10.5 13.5C8.5 11.5 8 9 8 9L8.35402 8.82299C9.28438 8.35781 9.70285 7.25714 9.31654 6.29136L8.50289 4.25722C8.19916 3.4979 7.46374 3 6.64593 3H5C3.89543 3 3 3.89543 3 5C3 13.8366 10.1634 21 19 21C20.1046 21 21 20.1046 21 19Z" stroke="#0d4047" stroke-width="1.5" stroke-linejoin="round" />
                          </svg>
                          {t("Call")}
                        </button>
                      </div>
                    </div>
                  </div>
                })
                : <div className='h-[400px] justify-center flex flex-col mx-auto items-center text-center'>
                  <img src={emptyimg} className='w-[200px]' alt="" />
                  <h1 className='font-[500] text-[18px]'>{t("No Booking placed !!")}</h1>
                  <p className='text-gray-400'>{t("Currently You Don't Have Any Booking")}</p>
                </div>)
              : (pastBooking.length >= 1
                ? pastBooking.map((item, index) => {
                  return <div key={index} onClick={() => HandleNavigate(item.id)} className="card-box">
                    <div className="relative">
                      <ImgLoad url={ImgBaseUrl + item.lab_logo} />
                      <div className={`absolute top-[5px] right-[5px] ${item.status === "7" ? "bg-red-100" : "bg-green-100"} px-[10px] rounded-[50px]`}>
                        <h1 className={`font-[500] ${item.status === "7" ? "text-red-500" : "text-green-700"}`}>{item.status_type}</h1>
                      </div>
                    </div>
                    <div className="p-[10px]">
                      <div className="flex items-center gap-[10px] justify-between">
                        <h1 className='text-[#0d4047] text-[17px]'>{t("Appointment ID")} {item.id}</h1>
                        <h1 className='font-[500] text-[#0d4047]'>{currency}{item.tot_price}.00</h1>
                      </div>
                      <h1 className='text-[16px] font-[500]'>{item.name}</h1>
                      <div className="flex items-center gap-[5px] text-gray-500">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#808080" stroke-width="1.5" />
                          <path d="M3 9H21" stroke="#808080" stroke-width="1.5" stroke-linecap="round" />
                          <path d="M8 2L8 5" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M16 2V5" stroke="#808080" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <circle cx="12" cy="15" r="1" fill="#808080" />
                          <circle cx="16" cy="15" r="1" fill="#808080" />
                          <circle cx="8" cy="15" r="1" fill="#808080" />
                        </svg>
                        <span className=' text-[14px] font-[500]'>{item.date}</span>
                      </div>
                      <div className="flex items-center justify-between gap-[10px] mt-[10px]">
                        {selectBtnref.current === 0 && <button onClick={(e) => { e.stopPropagation(); setIsCancelBox(item.id) }} className='w-[100%] border-[1px] border-[red] text-[red] rounded-[50px] py-[5px] font-[500]'>{t("Cancel")}</button>}
                        <button onClick={(e) => AudioCallHandler(e, item.country_code, item.phone)} className='w-[100%] border-[1px] border-[blue] text-[blue] rounded-[50px] py-[5px] font-[500] flex items-center justify-center gap-[10px]'>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 19V17.3541C21 16.5363 20.5021 15.8008 19.7428 15.4971L17.7086 14.6835C16.7429 14.2971 15.6422 14.7156 15.177 15.646L15 16C15 16 12.5 15.5 10.5 13.5C8.5 11.5 8 9 8 9L8.35402 8.82299C9.28438 8.35781 9.70285 7.25714 9.31654 6.29136L8.50289 4.25722C8.19916 3.4979 7.46374 3 6.64593 3H5C3.89543 3 3 3.89543 3 5C3 13.8366 10.1634 21 19 21C20.1046 21 21 20.1046 21 19Z" stroke="blue" stroke-width="1.5" stroke-linejoin="round" />
                          </svg>
                          {t("Call")}
                        </button>
                      </div>
                    </div>
                  </div>
                })
                : <div className='h-[400px] justify-center flex flex-col mx-auto items-center text-center'>
                  <img src={emptyimg} className='w-[200px]' alt="" />
                  <h1 className='font-[500] text-[18px]'>{t("No Booking placed !!")}</h1>
                  <p className='text-gray-400'>{t("Currently You Don't Have Any Booking")}</p>
                </div>)
            }
          </div>
        </div>}

      {isCancelBox && <div onClick={() => setIsCancelBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box max-h-[600px] scroll-container">
          <h1 className='font-bold text-center text-[18px]'>{t("Select Reason")}</h1>
          <p className='text-center text-[17px]'>{t("Please select the reason for cancellation")} : </p>
          <div className="px-[10px]">
            {cancelReasonList.map((item, index) => {
              return <div onClick={() => setSelectReason(item.id)} key={index} className="py-[5px] cursor-pointer flex items-center">
                <div className="w-[30px] check-box">
                  <input id="radio1" className="peer hidden" type="radio" name="group1" />
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectReason === item.id ? "box-activeborder" : "box-border"}`}>
                    <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectReason === item.id && "box-activebg"}`}></span>
                  </div>
                </div>
                <h1>{item.title}</h1>
              </div>
            })}
            {selectReason === 4 && <input type="text" onChange={(e) => setOtherReason(e.target.value)} className='border-[1px] focus-within:outline-[#0d4047] border-[#8080803b] w-[100%] py-[8px] px-[10px] rounded-[10px]' placeholder='Enter reason' />}
          </div>
          <div className="flex items-center gap-[20px] mt-[10px]">
            <button onClick={() => setIsCancelBox("")} className='w-[100%] bg-red-400 hover:bg-red-500 py-[6px] font-[500] text-white rounded-[50px]'>{t("Cancel")}</button>
            <button onClick={HandleCancelAppointment} className='w-[100%] bg-[#000000c2] hover:bg-black py-[6px] font-[500] text-white rounded-[50px]'>{t("Confrim")}</button>
          </div>
        </div>
      </div>}

      {deviceCheck && <div onClick={() => setDeviceCheck(false)} className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-[15px] p-4">
          <h6 className='m-0 font-[500] text-[18px] text-gray-600'>{t("Required for voice and video calls. Make")} <br /> {t("sure your audio device (headset, speakers,")}<br /> {t("or microphone) is connected and working.")}</h6>
        </div>
      </div>}

    </div>
  )
}

export default BookingPackage
/* jshint ignore:end */